import React from 'react';
import { styled } from '@mui/system';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import BasicButtons from './BasicButtons';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FileUploadButton = ({ onFileChange, buttonName, width }) => {
  const handleFileChange = (e) => {
    onFileChange(e.target.files);
  };

  return (
    <BasicButtons
      component="label"
      variant="contained"
      startIcon={<FilePresentIcon />}
      width={width}
    >
      {buttonName}
      <VisuallyHiddenInput
        type="file"
        onChange={handleFileChange}
        multiple
      />
    </BasicButtons>
  );
};

export default FileUploadButton;
